import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "_mb-6 gfu-bt--b1" }
const _hoisted_2 = { class: "_flexcol _gap-5" }
const _hoisted_3 = { class: "gfu-hd gfu-hd--h3 _mb-1" }
const _hoisted_4 = {
  key: 1,
  class: "gfu-bt--b1"
}
const _hoisted_5 = {
  key: 0,
  class: "_tac _mt-5 gfu-bt--b1"
}
const _hoisted_6 = {
  key: 1,
  class: "_tac _mt-3"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_title = _resolveComponent("base-title")
  const _component_external_link = _resolveComponent("external-link")
  const _component_localize = _resolveComponent("localize")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_title, {
      as: "h3",
      level: "h2"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.Resources.PledgeManager.SectionControlTitle), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.Resources.PledgeManager.SectionControlDescription), 1 /* TEXT */),
    _createVNode(_component_box, { huge: "" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("h3", _hoisted_3, _toDisplayString(item.title), 1 /* TEXT */),
              (item.url)
                ? (_openBlock(), _createBlock(_component_localize, {
                    key: 0,
                    tag: "div",
                    resource: item.description,
                    class: "gfu-bt--b1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_external_link, {
                        href: item.url,
                        class: "gfu-link gfu-link--accent _tdu",
                        "format-key": "0"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.linkText), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["href"])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["resource"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(item.description), 1 /* TEXT */))
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        ($props.summary)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($props.summary), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        ($props.actionLabel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_external_link, {
                href: $props.actionUrl,
                class: "gfu-link gfu-link--accent gfu-bt--b1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($props.actionLabel) + " ", 1 /* TEXT */),
                  _createVNode(_component_base_icon, { name: "chevron-right" })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["href"])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}